import { Link } from "react-router-dom";
import { Reveal } from "../Reveal";
import { catLabel } from "../../lib/api";

export const MostRead = ({ items = [] }) => {
  if (!items.length) return null;
  return (
    <section className="flip bg-ink text-cream py-16 sm:py-24" data-testid="most-read">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-10">
        <div className="flex items-end justify-between gap-4 border-b-[3px] border-cream pb-3 mb-4">
          <h2 className="display text-6xl sm:text-8xl">Most read</h2>
          <p className="kicker text-cream/75">This week</p>
        </div>
        <ol className="grid md:grid-cols-2 md:gap-x-14">
          {items.slice(0, 8).map((a, i) => (
            <Reveal as="li" key={a.slug} delay={0.04 * i} className="border-b border-cream/20">
              <Link to={`/article/${a.slug}`} className="group grid grid-cols-[56px_1fr_72px] sm:grid-cols-[84px_1fr_96px] gap-4 items-center py-5" data-testid={`most-read-${i}`}>
                <span className="wordmark text-pink text-6xl sm:text-7xl leading-[0.75] pb-[0.15em]">{i + 1}</span>
                <div className="min-w-0">
                  <p className="kicker text-blush">{catLabel(a.category)}</p>
                  <h3 className="display text-2xl sm:text-3xl mt-1 group-hover:opacity-60 transition-opacity">{a.title}</h3>
                </div>
                <div className="img-zoom aspect-square overflow-hidden bg-blush">
                  <img src={a.cover} alt="" loading="lazy" className="h-full w-full object-cover" />
                </div>
              </Link>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
};
